import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';
import { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { Dictionaries } from '@/api/dictionaries/types';
import { OrganizationShort } from '@/api/organizations/types';
import {
  IndividualSexLabel,
  IndividualStatus,
  IndividualStatusLabel,
} from '@/shared/vaccination/enums';
import { dictToOptions, enumToOptions } from '@/utils/utils';

export const editSchema = (
  dictionaries?: Dictionaries,
  organizations?: OrganizationShort[],
  structuals?: OrganizationShort[],
): IFormItem[] => [
  {
    label: 'Хозяйство',
    key: 'organizationId',
    type: 'select',
    payload: {
      options: organizations?.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    },
    readonly: true,
  },
  {
    label: 'Структурное подразделение',
    key: 'structuralDivisionId',
    type: 'select',
    payload: {
      options:
        structuals?.map((item) => ({
          label: item.name,
          value: item.id,
        })) || [],
    },
  },
  {
    label: 'Объект',
    placeholder: 'Выберите объект',
    key: 'individualLocationId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.INDIVIDUAL_LOCATION),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Инвентарный номер',
    key: 'inventoryNumber',
    type: 'text',
    readonly: true,
  },
  {
    label: 'Инвентарный номер матки',
    key: 'uterusInventoryNumber',
    type: 'text',
    readonly: true,
  },
  {
    label: 'Дата рождения',
    key: 'birthDate',
    type: 'date',
    readonly: true,
  },
  {
    label: 'Статус',
    placeholder: 'Выберите статус',
    key: 'individualStatus',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualStatusLabel),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Заболевание',
    placeholder: 'Введите заболевание',
    key: 'diseaseDescription',
    type: 'text',
    validation: (form) =>
      form.getFieldValue('individualStatus') !== IndividualStatus.SICK
        ? []
        : [Validators.required()],
    hidden: (form) => form.getFieldValue('individualStatus') !== IndividualStatus.SICK,
    payload: {
      maxLength: 250,
    },
  },
  {
    label: 'Дата падежа/выбытия',
    placeholder: 'Введите дату падежа/выбытия',
    key: 'deadRemovalDate',
    type: 'date',
    payload: {
      disabledDate: (current: DatePickerProps['value']) => {
        if (!current) return false;

        const today = dayjs().startOf('day');
        return current > today.endOf('day');
      },
    },
    validation: (form) =>
      ![IndividualStatus.DEAD, IndividualStatus.REMOVAL].includes(
        form.getFieldValue('individualStatus'),
      )
        ? []
        : [Validators.required()],
    hidden: (form) => {
      return ![IndividualStatus.DEAD, IndividualStatus.REMOVAL].includes(
        form.getFieldValue('individualStatus'),
      );
    },
  },
  {
    label: 'Вид животного',
    placeholder: 'Выберите вид животного',
    key: 'animalSpeciesId',
    type: 'select',
    payload: {
      options: dictToOptions(dictionaries?.ANIMAL_SPECIES),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Пол',
    key: 'sex',
    type: 'select',
    payload: {
      options: enumToOptions(IndividualSexLabel),
    },
    readonly: true,
  },
  {
    label: 'Животная масса (кг)',
    placeholder: 'Введите живую массу (кг)',
    key: 'liveWeight',
    type: 'number',
    validation: [Validators.required()],
  },
];
